import { createAgendaApi, updateAgendaApi, getAgendasApi, addToAgendaApi } from 'api/agenda';
import { Agenda } from 'models/agenda';

import { AGENDA_STATUSES } from 'constants/ProjectConstants';

export function createAgenda({ checkInInstanceId, questionId, text, status = AGENDA_STATUSES.active, uiKey }) {
  return createAgendaApi({
    checkInInstanceId,
    questionId,
    text,
    status,
    uiKey,
  }).then((res) => (res.entity ? Agenda.fromJSON(res.entity) : null));
}

export function updateAgenda({ agendaId, questionId, text, status, checkInInstanceId }) {
  return updateAgendaApi({
    agendaId,
    questionId,
    text,
    status,
    checkInInstanceId,
  }).then((res) => (res.entity ? Agenda.fromJSON(res.entity) : null));
}

export function getAgendas({ checkInId, limit = 5, offset = 0 }) {
  return getAgendasApi({ checkInId, limit, offset }).then((res) => res.entity.map((item) => Agenda.fromJSON(item)));
}

export function addToAgenda({ checkInInstanceId, questionId, label, levelUpInfo, uiKey }) {
  return addToAgendaApi({ checkInInstanceId, questionId, label, levelUpInfo, uiKey }).then((res) =>
    res.entity ? Agenda.fromJSON(res.entity) : null
  );
}
